/* Round 22: tidies the product description on the generalized product page (hides empty bits and lines already shown as bubbles). */
(function () {
  'use strict';
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function run(ctx) {
    // generalized page: tidy the description (hide empty bits and lines already shown as step or policy bubbles)
    var DUP = [/check your email.*free shipping code/, /(packs|bundles) are (opened|ripped) live on stream/, /only hits.*holos.*(sent|bulk)/, /cannot be refunded/, /free shipping for orders over \$99/];
    $all('[data-hp-desc]', ctx).forEach(function (box) {
      if (box.__hpDesc) return; box.__hpDesc = true;
      // Holo (Oct 12 2026): Holo Hit Box shows its full ADDITIONAL INFORMATION list (no dedup against the policy bubbles)
      var hasBubbles = !/^\/products\/holo-hit-box\/?$/.test(location.pathname) && !!box.parentNode.querySelector('.hp-pol, .hp-step');
      var hasOffer = !!document.querySelector('.hp-pol--offer');
      $all('li, p, h1, h2, h3, h4', box).forEach(function (el) {
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        if (!t && !el.querySelector('img')) { el.classList.add('hp-empty'); return; }
        if (hasBubbles && el.tagName === 'LI' && DUP.some(function (re) { return re.test(t); })) el.classList.add('hp-dup');
        // the box offer is shown once, as the side bubble
        else if (hasOffer && (el.tagName === 'LI' || el.tagName === 'P') && /receive.*booster box/.test(t) && t.length < 160) el.classList.add('hp-dup');
      });
      $all('ul, ol', box).forEach(function (ul) {
        if (!ul.querySelector('li:not(.hp-dup):not(.hp-empty)')) {
          ul.classList.add('hp-empty');
          var h = ul.previousElementSibling;
          while (h && h.classList.contains('hp-empty')) h = h.previousElementSibling;
          if (h && /^H[1-4]$/.test(h.tagName) && /^(important|additional information)$/.test((h.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase())) h.classList.add('hp-empty');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
